var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompetence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.5 24.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "horse_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M960.49,240.22a3.12,3.12,0,0,1,1.67,2.81.56.56,0,0,0,.24.48,1,1,0,0,0,.62.2h12.29a.79.79,0,0,0,.87-.62c.23-4.38-4.32-7.29-6.31-8.35a25.67,25.67,0,0,1,6.35.92l.12,0a2.85,2.85,0,0,0,2.25-.46,2.42,2.42,0,0,0,.48-2.61.65.65,0,0,0-.15-.23,45.33,45.33,0,0,0-6.15-3.94l-.56-.76a.89.89,0,0,0-.61-.32l-2.14-.29V224.6l-1,.11a6.3,6.3,0,0,0-4.59,2.26,6.67,6.67,0,0,0-3.22,1.4l-.08,0a1.07,1.07,0,0,0-1.22.13.57.57,0,0,0,.18.92l1.52.84a1.07,1.07,0,0,0,1.21-.13.56.56,0,0,0-.18-.92h0a4.64,4.64,0,0,1,2.43-.94l.58,0,.2-.41a3.76,3.76,0,0,1,2.46-1.61v1.45a.79.79,0,0,0,.87.66h0l.11,0,2.15.28.46.61a.68.68,0,0,0,.24.2,52.67,52.67,0,0,1,5.83,3.67c.12.44.15,1.05-.11,1.26a1,1,0,0,1-.61.07c-1.63-.4-6.68-1.55-8.38-.58a1.16,1.16,0,0,0-.66,1.08.67.67,0,0,0,.44.53c.06,0,6,2.67,6.33,7H963.85a4.22,4.22,0,0,0-2.43-3.3c-2.13-1-2.69-2-2.36-4.6h0l.25,0a.9.9,0,0,0,.84-.47c.13-.35-.13-.71-.59-.81l-1.92-.44a1,1,0,0,0-1.08.44c-.14.35.12.71.58.82l.2,0c-.4,2.79,0,4.61,3.13,6.09",
    transform: "translate(-956.54 -224.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M958.07,231.7l1.7.61a1.19,1.19,0,0,0,.37.06.94.94,0,0,0,.79-.37c.21-.33,0-.72-.41-.87l-1.71-.61a1,1,0,0,0-1.16.31c-.2.32,0,.71.42.87",
    transform: "translate(-956.54 -224.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M960.52,248.24a5.28,5.28,0,0,1,1.52-1.83h14.05a5.19,5.19,0,0,1,1.53,1.83Zm19.18.46c-.12-.29-1.2-2.79-2.91-3.52a1.11,1.11,0,0,0-.54-.07H961.82a1.16,1.16,0,0,0-.48.08c-1.71.73-2.78,3.23-2.9,3.52l-.35.84H980Z",
    transform: "translate(-956.54 -224.6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetence);
export default __webpack_public_path__ + "static/media/competence.d0a82601.svg";
export { ForwardRef as ReactComponent };